package io.horion.auth.api.models.domain

import kotlinx.serialization.Serializable

@Serializable
data class Send2FaOtpRequest(
    val channelValue: String, // email ou téléphone à vérifier
)

@Serializable
data class Verify2FaOtpRequest(
    val channelValue: String,
    val code: String
)

@Serializable
data class Toggle2FaRequest(
    val enable: Boolean
)

@Serializable
data class Generic2FaResponse(
    val success: Boolean,
    val message: String? = null
)